<template>
	<div class="grid-flex-container">
		<v-container fluid>
			<v-row no-gutters>
				<div style="flex-grow: 1">
					<v-text-field
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn color="primary" @click="addUser()">
						<v-icon> mdi-plus</v-icon>
						&nbsp;&nbsp;Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				:headers="headers"
				:items="items"
				:search.sync="search"
				:sort-desc="[true]"
				:loading="loading"
				hide-default-footer
				:disable-pagination="true"
				loading-text="Loading..."
				fixed-header
				multi-sort
				dense
			>
				<template v-slot:[`item.LastLogin`]="{ item }">
					{{ getDateTimeFormat(item.LastLogin) }}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<div class="d-flex">
						<v-spacer />
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="success"
							@click="editUser(item)"
						>
							<v-icon small> mdi-pencil </v-icon>
						</v-btn>
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="error"
							@click="deleteUser(item.Id)"
						>
							<v-icon small> mdi-delete</v-icon>
						</v-btn>
					</div>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { AdminUserManagementActions } from '../../../store/actions';
import { AdminUserManagementGetters } from '../../../store/getters';
import permissionsMixin from '../../../mixins/permissionsMixin';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';

export default {
	name: 'AdminUserManagement',
	mixins: [permissionsMixin, projectSettingsMixin],
	components: {},
	data() {
		return {
			showDialog: false,
			headers: [
				{
					text: 'Last Name',
					value: 'LastName',
				},
				{
					text: 'First Name',
					value: 'FirstName',
				},
				{
					text: 'Email',
					value: 'Email',
				},
				{
					text: 'Last Login',
					value: 'LastLogin',
				},
				{
					sortable: false,
					text: '',
					value: 'actions',
				},
			],
			search: '',
		};
	},
	computed: {
		...mapGetters({
			items: [AdminUserManagementGetters.GET_DATA],
			loading: [AdminUserManagementGetters.GRID_LOADING],
		}),
	},
	mounted() {
		this.getUsers();
	},
	destroyed() {
		this.$store.dispatch(AdminUserManagementActions.CLEAR);
	},
	methods: {
		getUsers() {
			this.$store
				.dispatch(AdminUserManagementActions.LOAD_DATA)
				.then(() => {});
		},
		addUser() {
			this.$router.push({
				name: 'AdminUserManagementAdd',
				params: { id: null },
			});
		},
		editUser(item) {
			this.$router.push({
				name: 'AdminUserManagementEdit',
				params: { id: item.Id },
			});
		},
		deleteUser(id) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this user?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$store
						.dispatch(AdminUserManagementActions.DELETE, id)
						.then(() => {
							this.getUsers();
						});
				}
			});
		},
		onAddUserModalCancel() {
			this.showDialog = false;
		},
		onAddUserModalSubmit() {
			this.getUsers();
			this.showDialog = false;
		},
	},
};
</script>
